export default "__VITE_ASSET__BecAVRtb__"